import {APhoneField} from "../services/types.generated"

export const phoneToString = (phone: APhoneField | string | null | undefined): string | null => {
  if (phone == null) {
    return null
  }
  if (typeof phone === "string") {
    return phone
  }
  return phone.number ?? null
}
